export default class User {
    constructor(json) {
        json = json || {};
        this.account = json.account || '';
        this.email = json.email || '';
        this.first_name = json.first_name || '';
        this.last_name = json.last_name || '';
        this.icon = json.icon || '';
    }
}